<template>
  <div class="invite_wrapper">
    <div class="banner">
      <div class="href" @click="top"></div>
      <div class="image">
        <img src="@/assets/我的邀请.png" alt="" />
      </div>

      <div class="invite_table">
        <div class="total">
          <div class="total_num">
            <div class="num">
              {{
                order_account.incomeInviter ? order_account.incomeInviter : 0
              }}
            </div>
            <div class="text">邀请奖励</div>
          </div>
          <div class="total_num">
            <div class="num" style=" color: #ff4e50;">
              {{ order_account.uid ? order_account.uid : 0 }}
            </div>
            <div class="text">下单用户数</div>
          </div>
          <div class="total_num">
            <div class="num " style=" color: #ff4e50;">
              {{
                order_account.incomeInviter ? order_account.incomeInviter : 0
              }}
            </div>
            <div class="text">子订单总数</div>
          </div>
        </div>
        <div class="list">
          <div class="list_header">
            <div class="list_header_item">
              用户ID
            </div>
            <div class="list_header_item">
              子订单数
            </div>
            <div class="list_header_item">
              推广利润
            </div>
          </div>

          <van-list
            v-show="account_list.length > 0"
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            :immediate-check="false"
            style="height:300px;overflow:auto"
          >
            <div class="list_data" v-for="item in account_list" :key="item.id">
              <div class="list_data_item">
                {{
                  item.uid.substring(0, 4) +
                    '****' +
                    item.uid.substring(item.uid.split('').length - 4)
                }}
              </div>
              <div class="list_data_item">
                {{ item.count }}
              </div>
              <div class="list_data_item">
                {{ item.incomeInviter }}
              </div>
            </div>
          </van-list>

          <div v-show="account_list.length < 1" class="empty">
            <img src="@/assets/空状态_插画.png" alt="" />
            <span>
              暂无数据
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="my_invite">
      <div class="image">
        <img src="@/assets/邀请攻略.png" alt="" />
      </div>
      <div class="step">
        <div class="top">
          <div class="line"></div>
          <div class="item">1</div>
          <div class="item">2</div>
          <div class="item">3</div>
        </div>
        <div class="text">
          <div class="text_item">
            复制链接或生成海报，分享给好友
          </div>
          <div class="text_item">
            好友注册 并成功下单
          </div>
          <div class="text_item">
            您将获得，一定比例的佣金奖励
          </div>
        </div>
        <div class="btn">
          <div class="copy" @click="copyInviteKey">复制链接</div>
          <div class="pic" @click="toPost">生成海报</div>
          <input class="input" />
        </div>
      </div>
    </div>
    <div class="activity_desc" id="activity_desc">
      <div class="image">
        <img src="@/assets/活动奖励.png" alt="" />
      </div>
      <div class="desc">
        1. 好友通过你分享的邀请码或链接注册成功，即可成为你的 推广用户。
      </div>
      <div class="desc">
        2.分享链接给好友，当好友通过您的分享，成功注册并下单，您将获得一定比例的佣金奖励。
      </div>
      <div class="desc">
        3. 活动最终解释权归速代发礼品网所有。
      </div>
    </div>
  </div>
</template>

<script>
import { accountGet, orderCount, orderList } from '@/api';
export default {
  data() {
    return {
      baseData: baseData,
      invitekey: '',
      account: {},
      order_account: {},
      account_list: [],
      loading: false,
      finished: false,
      page: {
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  mounted() {
    accountGet().then((res) => {
      this.account = res.data;
      this.invitekey =
        'http://' + baseData.host + '/mobile/register?c=' + this.account.code;
    });
    orderCount({ pageNum: 1, pageSize: 20 }, 5).then((res) => {
      this.order_account = res.data;
    });
    this.account_list = [];
    this.page.pageNum = 1;
    this.loading = false;
    this.finished = false;
    this.getOrderList();
  },
  methods: {
    top() {
      var activity_desc = document.getElementById('activity_desc');
      activity_desc.scrollIntoView();
    },
    copyInviteKey() {
      var input = document.querySelector('.input');
      input.value =
        '我发现一个电商人必备的礼品代发网站，注册网址是' + this.invitekey;
      input.select();
      input.setSelectionRange(0, input.value.length);
      document.execCommand('Copy');
      this.$toast.success('复制成功');
    },
    toPost() {
      this.$router.push({ name: 'post' });
    },
    getOrderList() {
      orderList(this.page, 5).then((res) => {
        if (res.success) {
          //数据拼接
          this.account_list = [...this.account_list, ...res.data.list];
          //加载为fasle
          this.loading = false;
          if (res.data.page.total == this.account_list.length) {
            this.finished = true;
            console.log('获取到全部了');
          }
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    onLoad() {
      console.log('触底');
      this.page.pageNum++;
      this.getOrderList();
    }
  }
};
</script>

<style lang="less" scoped>
.invite_wrapper {
  .banner {
    background-image: url(~@/assets/extension_bg.png);
    background-size: cover;
    padding: 0 4.267vw;
    height: 190.933vw;
    .href {
      width: 17.067vw;
      height: 5.333vw;
      position: absolute;
      right: 4vw;
      top: 10px;
    }
    .image {
      width: 46.667vw;
      margin: 0 auto 4vw;
      padding-top: 56.267vw;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .invite_table {
      background: #ffffff;
      padding-bottom: 3.2vw;
      border-radius: 16px;

      .total {
        padding: 9.067vw 0 4.667vw;
        border-bottom: 2px dashed #ff4e50;
        opacity: 0.5;
        display: flex;
        .total_num {
          flex: 1;
          text-align: center;
          .num {
            font-size: 5.333vw;
            color: rgba(0, 0, 0, 0.65);
            margin-bottom: 1.067vw;
            line-height: 1.5;
          }
          .text {
            font-size: 3.2vw;
            color: #323233;
          }
        }
      }
      .list {
        margin: 4.267vw 3.2vw 0;

        border-radius: 2.133vw 2.133vw 0vw 0vw;

        &_header {
          background: #ffeaea;
          height: 10.667vw;
          color: #ff4e50;
          font-size: 4vw;
          display: flex;
          opacity: 1;
          &_item {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
          }
        }
        &_data {
          background-color: #fff3f3;
          display: flex;
          background: #ffeaea;
          &_item {
            flex: 1;
            height: 9.6vw;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 3.467vw;
            color: #7d7e80;
          }
        }
        .empty {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 19.733vw;
          img {
            width: 61.333vw;
            height: 46.533vw;
            margin-bottom: 6.4vw;
          }
        }
      }
    }
  }
  .my_invite {
    background: #ff4e50;
    padding: 5.6vw 4.267vw 0;
    .image {
      width: 46.667vw;
      margin: 0 auto 4vw;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .step {
      width: 91.467vw;
      background: #ffffff;
      opacity: 0.98;
      border-radius: 2.133vw;
      padding: 10.667vw 0 9.6vw;
      .top {
        display: flex;
        position: relative;
        padding: 0 12.933vw;
        justify-content: space-between;
        margin-bottom: 3.2vw;
        .line {
          width: 64.533vw;
          border: 1px dashed #ff4e50;
          opacity: 0.5;
          margin: 0 12.933vw;
          position: absolute;
          top: 3.733vw;
          left: 0;
        }
        .item {
          z-index: 10000;
          width: 7.467vw;
          height: 7.467vw;
          border-radius: 50%;
          background: linear-gradient(180deg, #fd7343 0%, #ff4e50 100%);
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;

          font-size: 5.333vw;
          font-family: Noto Sans CJK;
        }
      }
      .text {
        display: flex;
        color: #ff4e50;
        font-size: 3.2vw;
        padding: 0 3.2vw;
        margin-bottom: 10.4vw;
        &_item {
          margin-right: 2.133vw;
          line-height: 1.5;
          text-align: center;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .btn {
        display: flex;
        padding: 0 4.267vw;
        .input {
          width: 1.333vw;
          opacity: 0;
        }
        .copy,
        .pic {
          width: 39.2vw;
          height: 10.667vw;
          border: 2px solid #ff4e50;
          border-radius: 1.067vw;
          font-size: 4.533vw;
          color: #ff4e50;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
        }
        .pic {
          margin-left: 4.533vw;
          border: 0;
          background: linear-gradient(180deg, #fd7343 0%, #ff4e50 100%);
          color: #fff;
        }
      }
    }
  }
  .activity_desc {
    padding: 0 4.267vw 19.733vw;
    background: #ff4e50;

    .image {
      width: 46.667vw;
      margin: 0 auto 5.067vw;
      padding-top: 11.067vw;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .desc {
      color: #fff;
      font-size: 3.467vw;
      line-height: 1.5;
      margin-bottom: 3.2vw;
    }
  }
}
</style>
